module.exports = __webpack_public_path__ + "img/01.dcb6dc36.jpg";